import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import SellerLayout from './SellerLayout';

const SellerCouponEdit = () => {

  const navigate = useNavigate();
  const { couponId } = useParams();

  const [shopName,setShopName] = useState('');

  const [form,setForm] = useState({
    id:'',
    coupon_name:'',
    discount_type:'amount',
    discount_value:'',
    min_order_price:'',
    start_date:'',
    end_date:'',
    active:1
  });

  useEffect(()=>{

    loadCoupon();

  },[couponId]);

  const loadCoupon = async () => {

    try{

      const res = await axios.get(
        `/api/seller/coupon/detail?coupon_id=${couponId}`
      );

      setShopName(res.data.shop_name || '');

      const coupon = res.data.coupon;

      if(!coupon){
        alert('쿠폰이 없습니다.');
        navigate('/seller/coupon/manage');
        return;
      }

      setForm({
        id:coupon.id,
        coupon_name:coupon.coupon_name || '',
        discount_type:coupon.discount_type || 'amount',
        discount_value:coupon.discount_value || '',
        min_order_price:coupon.min_order_price || '',
        start_date: coupon.start_date || '',
        end_date: coupon.end_date || '',
        active:coupon.active ?? 1
      });

    }catch(err){

      alert('쿠폰 정보를 불러오지 못했습니다.');

    }
  };

  const updateCoupon = async () => {

    try{

      await axios.post(
        '/api/seller/coupon/update',
        form
      );

      alert('수정 완료');

      navigate('/seller/coupon/manage');

    }catch(err){

      alert('수정 실패');

    }
  };

  return (
    <SellerLayout shopName={shopName}>
      <div className="container mt-4">

        <h3 className="mb-4">
          쿠폰 수정
        </h3>

        <div className="mb-3">
          <label className="form-label">
            쿠폰명
          </label>

          <input
            className="form-control"
            value={form.coupon_name}
            onChange={e=>
              setForm({
                ...form,
                coupon_name:e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label">
            할인방식
          </label>

          <select
            className="form-select"
            value={form.discount_type}
            onChange={e=>
              setForm({
                ...form,
                discount_type:e.target.value
              })
            }
          >
            <option value="amount">
              금액할인
            </option>

            <option value="percent">
              퍼센트할인
            </option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">
            할인값
          </label>

          <input
            className="form-control"
            value={form.discount_value}
            onChange={e=>
              setForm({
                ...form,
                discount_value:e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label">
            최소주문금액
          </label>

          <input
            className="form-control"
            value={form.min_order_price}
            onChange={e=>
              setForm({
                ...form,
                min_order_price:e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label">
            시작일
          </label>

          <input
            type="datetime-local"
            className="form-control"
            value={form.start_date}
            onChange={e=>
              setForm({
                ...form,
                start_date:e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label">
            종료일
          </label>

          <input
            type="datetime-local"
            className="form-control"
            value={form.end_date}
            onChange={e=>
              setForm({
                ...form,
                end_date:e.target.value
              })
            }
          />
        </div>

        <div className="mb-4">
          <label className="form-label">
            사용여부
          </label>

          <select
            className="form-select"
            value={form.active}
            onChange={e=>
              setForm({
                ...form,
                active:Number(e.target.value)
              })
            }
          >
            <option value="1">
              사용
            </option>

            <option value="0">
              중지
            </option>
          </select>
        </div>

        <button
          className="btn btn-primary me-2"
          onClick={updateCoupon}
        >
          저장
        </button>

        <button
          className="btn btn-secondary"
          onClick={()=>
            navigate('/seller/coupon/manage')
          }
        >
          취소
        </button>

      </div>
    </SellerLayout>
  );
};

export default SellerCouponEdit;